<template lang="html">
  <v-avatar 
    v-bind="$attrs" 
    :color="_userProfileColor(internalUid) || 'primary'" 
    v-on="$listeners"
  >
    <img 
      v-if="_userProfileImage(internalUid)" 
      v-show="loaded" 
      :src="_userProfileImage(internalUid)" 
      alt="alt"
      @load="loaded = true"
    >
    <span 
      v-if="!_userProfileImage(internalUid) || !loaded" 
      class="white--text"
    >{{ _userInitials(internalUid) }}
    </span>
  </v-avatar>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "@/mixins/helpers";
import users from "@/mixins/users";

export default {
  mixins: [helpers, users],
  props: {
    uid: String,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapGetters(["_user"]),
    internalUid() {
      if (this.uid) return this.uid;
      if (this.uid === false) return null;
      return this._user.uid;
    },
  },
};
</script>

<style lang="css" scoped>
</style>
